<template>

	<div class="app_index clearfix">
		<section class="p_background apply_top">
			<h3 class="all_title">统计信息</h3>
			<div id="statistical_information"></div>
		</section>
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-6 apply_btm_left">
					<section class="p_background">
						<h3 class="all_title">管理应用</h3>
						
						<div class="manage_app_box text-center">
							<div class="container-fluid">
								<div class="row">
									<section class="col-sm-6">
										<span class="btn btn_create" @click="routerToPage('/add_app')">创建应用</span>
									</section>
									<section class="col-sm-6">
										<span class="btn btn_manage" @click="routerToPage('/all_app')">应用管理</span>
									</section>
								</div>
							</div>
							
							<p><small class="tip_sub_text">共{{applyNum}}款应用</small></p>
						</div>
						
					</section>

				</div>
				<!-- apply_btm_left / -->

				<div class="col-sm-6 apply_btm_right">
					<section class="p_background">
						<h3 class="all_title clearfix">
							消息列表
							<router-link to="/message_list" class="pull-right">更多>></router-link>
						</h3>
						<div class="message_list_box">
							<p v-if="msglist.length == 0" class="text-center color_9">暂无消息</p>
							<p class="cursor" v-else v-for="msg in msglist" >
								<a @click="view(msg.id)" class="cursor">
									<span class="message_list_title text-right text-space" v-html="msg.messageTitle"></span>:
									<span class="message_list_text text-space">{{msg.messageComment}}</span>
									<span class="message_list_time text-right">{{msg.messageSendTime | datetime}}</span>
								</a>
							</p>
						</div>
					</section>
				</div>
				<!-- apply_btm_right / -->

			</div>
			<!-- row / -->
		</div>
		<!-- container / -->
	</div>
</template>

<script>
	import echarts from 'echarts';
	
	export default {
		data() {
			return {
				applyNum: '',
				msglist: [],
				bbNums: ''
			};
		},
		methods: {
			leftHide(){
				var a = $(".app_index");
				var b = $(a).parents("body").find(".menu_left");
				if( $(b).length != '0' ){
					$(b).animate({
						left: '-100%'
					},300)
				}
				
			},
			//跳转路由
			routerToPage(url){
				this.$router.push(url)
			},
			//获取应用数量
		    getApplyNum(){
		    	var temp = this;
		      	this.$http.post('/zklccloud/findTCloudApps',{emulateJSON:true}).then(function(m){
		      	this.applyNum=m.body.data
		      })
		    },
		    //获取消息列表
		    getAllMessages(){
		    	var temp = this;
		      	this.$http.post('/zklccloud/findTCloudMessages',{"messageType":1,"messageStatus":'',"page":0,"size":3},{emulateJSON:true}).then(function(m){
		      	this.msglist=m.data.content.page.content
		      })
		    },
		    //根据id查询消息详情
		    view(id){
		    	localStorage.setItem('messageId',id);
		    	this.$router.push('/read_message')
		    },
		    //获取未读消息的总条数
		   	getMCount(){
			    	var temp = this;
			      	this.$http.post('/zklccloud/findTCloudMessagesCount',{"messageStatusType":1,"messageStatus":0},{emulateJSON:true}).then(function(m){
			      	this.$store.state.count=m.body.data
			    })
			},
		  //获取前五条未读消息
			getMessageTopList(){
		    	var temp = this;
		      	this.$http.post('/zklccloud/findTCloudMessages',{"messageStatusType":1,"messageStatus":0,"page":0,"size":5},{emulateJSON:true}).then(function(m){
		      	this.$store.state.msgList = m.data.content.page
		      })
		  	},
			drawPie(id , data) {
				var chart = echarts.init(document.getElementById(id));
				chart.setOption ({
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						 x: 'left',
				      	 y:'center',
				     	 orient:'vertical',
				     	 left:'8%',
						data: ['下载数量']
					},
					grid: {
						left: '25%',
						right: '10%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
					},
					yAxis: {
						type: 'value',
						axisLabel: {
							formatter: '{value}'
						}
					},
					series: [
						{
							name: '下载数量',
							type: 'line',
							stack: '数量',
							data: data
						}
					]
				});
//				chart.setOption({
//					tooltip: {
//						trigger: 'axis'
//					},
//					legend: {
//						 x: 'left',
//				      	 y:'center',
//				     	 orient:'vertical',
//				     	 left:'8%',
//						data: ['下载数量']
//					},
//					grid: {
//						left: '25%',
//						right: '10%',
//						bottom: '3%',
//						containLabel: true
//					},
//					xAxis: {
//						type: 'category',
//						boundaryGap: false,
//						data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
//					},
//					yAxis: {
//						type: 'value'
//					},
//					series: [{
//							name: '下载数量',
//							type: 'line',
//							stack: '数量',
//							data: data
//						}
//					]
//				});
			}
		},
		mounted() {
			this.$nextTick(function() {
				//初始化应用数量的方法
				this.getApplyNum();
				//初始化消息列表的方法
				this.getAllMessages();
				//初始化获取未读消息的总条数方法
				this.getMCount();
				//初始化获取前五条未读消息
				this.getMessageTopList();
				//初始化报表方法
				var temp = this;
		      	this.$http.post('/zklccloud/findAppDownLogs',{emulateJSON:true}).then(function(m){
			      	temp.bbNums=m.body.content.data,
			      	temp.drawPie('statistical_information',this.bbNums);
		      	})
		      	
				var that = this;
				var resizeTimer = null;
//				window.onresize = function() {
//					if(resizeTimer) clearTimeout(resizeTimer);
//					resizeTimer = setTimeout(function() {
//						that.drawPie('statistical_information');
//					}, 100);
//				}
			});
		}
	}
</script>

<style>
	
	#statistical_information {
		 position: relative;
	    /*left: 50%;*/
	    width: 100%;
	    height: 400px;
	    /*margin-left: -25%;*/
	}
</style>


// WEBPACK FOOTER //
// app_index.vue?26bdc53e